<template>
    <div>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Course Listing</v-toolbar-title>
                <v-spacer />
                <search-filter v-model="keywordSearch" />
                <v-btn v-if="isAdmin" color="secondary" dark @click="addDialog = true">
                    Add
                </v-btn>
                <v-btn v-if="isAdmin" color="secondary" dark :loading="exporting" @click="exportCourses()">
                    Export
                </v-btn>
            </v-toolbar>
            <v-data-table :headers="headers" :items="listData" :pagination.sync="pagination" :total-items="totalRecords" :loading="loading" :rows-per-page-items="rowsPerPageItems">
                <v-progress-linear slot="progress" color="secondary" indeterminate />
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.title }}</td>
                    <td><span v-if="props.item.user">{{ props.item.user.fullName }}</span></td>
                    <td><span v-if="props.item.authorshipTeamDisplay">{{ props.item.authorshipTeamDisplay }}</span></td>
                    <td><span v-if="props.item.workflowStatus">{{ props.item.workflowStatus.name }}</span></td>
                    <td>{{ props.item.lastCourseUpdateDisplay | formatDate }}</td></td>
                    <td><span v-if="props.item.nextReviewDateDisplay">{{ props.item.nextReviewDateDisplay | formatDate }}</span></td>
                    <td class="text-xs-center">
                        <v-icon v-if="props.item.active" color="green">
                            far fa-check-circle
                        </v-icon>
                    </td>
                    <td class="text-xs-right">
                        <div style="width:30px; display:flex">
                            <v-icon class="mr-3" @click="goToUrl(`/AuthorDashboard/ManageCourse/${props.item.id}`)">
                                far fa-edit
                            </v-icon>
                            <v-icon @click="deleteCourse(props.item)">
                                far fa-trash-alt
                            </v-icon>
                        </div>
                    </td>
                </template>
            </v-data-table>
        </v-card>

        <add-course :dialog.sync="addDialog" @getCourses="getCourses" />
    </div>
</template>
<script>
    import _ from 'lodash';
    import localforage from 'localforage';
    import axios from 'axios';
    import AddCourse from './components/AddCourse';

    export default {
        parent: true,

        components: {
            AddCourse,
        },

        props: {
            isAdmin: {
                type: Boolean,
                default: false,
            },
        },

        data: () => ({
            exporting: false,
            loading: true,
            listData: [],
            totalRecords: 0,
            rowsPerPageItems: [1, 20, 50, 75, 100],
            pagination: {
                descending: false, page: 1, rowsPerPage: 20, sortBy: 'title', totalItems: 0,
            },
            headers: [
                { text: 'Courses', value: 'title', align: 'left' },
                {
                    text: 'Primary Author', value: 'user.fullName', align: 'left',
                },
                {
                    text: 'Author Team', value: 'authorshipTeamDisplay', align: 'left',
                },
                {
                    text: 'Status', value: 'workflowStatus.name', align: 'left',
                },
                {
                    text: 'Last Updated', value: 'updatedAt', align: 'left',
                },
                {
                    text: 'Next Scheduled', value: 'nextReviewDate', align: 'left',
                },
                {
                    text: 'Published', value: 'active', align: 'center',
                },
                {
                    align: 'right', sortable: false,
                },
            ],
            keywordSearch: '',
            addDialog: false,
        }),

        watch: {
            pagination: {
                handler(newval, oldval) {
                    if (!_.isEqual(newval, oldval)) {
                        this.getCourses();
                    }
                },
                deep: true,
            },

            'pagination.rowsPerPage': function (val) {
                localforage.setItem('CourseListingGrid:RowsPerPage', val);
            },

            keywordSearch() {
                this.processSearch();
            },
        },

        mounted() {
            localforage.getItem('CourseListingGrid:RowsPerPage').then((value) => {
                this.pagination.rowsPerPage = value || 20;
                this.getCourses();
            });
        },

        methods: {
            async getCourses() {
                const {
                    sortBy, descending, page, rowsPerPage,
                } = this.pagination;
                const sortDirection = descending ? `${sortBy} DESC` : `${sortBy} ASC`;
                this.loading = true;
                const { data } = await axios.get(`/api/courses?currentPage=${page}&pageSize=${rowsPerPage}&sortDirection=${sortDirection}&filter=${this.keywordSearch}`);
                this.listData = data.resultItems;
                this.totalRecords = data.totalRecords;
                this.loading = false;
            },

            async exportCourses() {
                this.exporting = true;
                const { data } = await axios.get('/api/courses/export', {
                    responseType: 'blob',
                });
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'export.xlsx');
                document.body.appendChild(link);
                link.click();
                this.exporting = false;
            },

            async deleteCourse(course) {
                const result = confirm('Are you sure you want to delete this course? It will no longer be available in the system and this cannot be undone'); // eslint-disable-line
                if (result) {
                    await axios.delete(`/api/courses/${course.id}`);
                    await this.getCourses();
                }
            },

            processSearch: _.debounce(function () {
                this.getCourses();
            }, 600),
        },
    };
</script>